<app-nav-bar></app-nav-bar>
<mat-card class="pwrapper">
  <div>
      <url-gen></url-gen>
  </div>
</mat-card>